import React from 'react';
import styled from 'styled-components';

import { DataElementContext } from '../../../../page-components/common/DataElementContext';
import evBus from '../../../../utils/evbus';
import { useAppSelector } from '@/store';
import { SocialCapability } from '..';

type SocialHubTogglerProps = {
  children: any;
  styleText: string;
  className: string;
  properties?: {
    dsType: string;
    eventBusType: string;
  };
};

const defaultProps = {
  className: '',
  styleText: '',
  properties: {
    dsType: '',
  },
};

const ModuleElementDiv = styled.div<{ $styleText: string }>((props) => props.$styleText);

const SocialHubToggler = (componentProps: SocialHubTogglerProps) => {
  const props = componentProps;

  const hashParams = window.location.hash.substring(1);
  const params = new URLSearchParams(hashParams);
  const hashPostId = params.get('postId');

  const [state, setState] = React.useState({
    open: hashPostId ? true : false,
    defaultTabOpened: '',
  });
  const eventBusType = props.properties?.eventBusType;

  const socialCapabilities = useAppSelector((state) => state.social.flags?.social_capabilities);
  const profile = useAppSelector((state) => state.profile);
  const canViewSocial =
    socialCapabilities?.includes?.(SocialCapability.CHAT_CAN_VIEW) ||
    socialCapabilities?.includes?.(SocialCapability.FEED_CAN_VIEW);

  const onToggle = (data: string) => {
    setState((prevState) => {
      const newState = {
        ...prevState,
        open: !prevState.open,
      };

      if (data && typeof data === 'string') {
        newState.defaultTabOpened = data;
      }

      return newState;
    });
  };

  React.useEffect(() => {
    if (eventBusType) {
      evBus.on(eventBusType, onToggle);
    }

    return () => {
      if (eventBusType) {
        evBus.remove(eventBusType, onToggle);
      }
    };
  }, [eventBusType]);

  const contextValue = React.useMemo(() => {
    return {
      open: state.open,
      defaultTabOpened: state.defaultTabOpened,
      onToggle: onToggle,
      canViewSocial,
      isGuest: profile.client_player_id === null,
    };
  }, [state, onToggle, eventBusType, canViewSocial, profile]);

  return (
    <ModuleElementDiv className={props.className ?? ''} $styleText={props.styleText}>
      <DataElementContext.Provider value={contextValue}>{componentProps.children}</DataElementContext.Provider>
    </ModuleElementDiv>
  );
};

export default SocialHubToggler;
